import React from 'react';
import { CheckIcon } from 'lucide-react';
import { topics, included } from '../data/content';
export function Overview() {
  const stats = [{
    value: '+300',
    label: 'ideas'
  }, {
    value: '11',
    label: 'tomos'
  }, {
    value: 'Paso a paso',
    label: 'en cada guía'
  }];
  return <section aria-labelledby="overview-title" className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-142" data-mp="12v7m4j60dzup">
      <div className="text-center" data-id="element-143" data-mp="o6tfdx5h1r8v">
        <p className="font-display text-lg font-semibold text-pumpkin" data-id="element-144" data-mp="o5rwj6i7s0gl">Recursos Practic &amp; Simple</p>
        <h2 id="overview-title" className="mx-auto mt-3 max-w-3xl font-display text-4xl font-bold leading-tight text-bone sm:text-5xl" data-id="element-145" data-mp="syuq3emzr9ws">
          El Megapack de Halloween N°1 en Argentina
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-mist" data-id="element-146" data-mp="j802a5u3k298">
          Sistema completo · 6 Tomos + 3 Extras + 2 Premium · Familias con chicos · Todo resuelto.
        </p>
      </div>

      <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-3 divide-x divide-line" data-id="element-147" data-mp="a5h2xvpis7rq">
        {stats.map(s => <div key={s.label} className="px-3 text-center" data-id="element-148" data-mp="awuqdrmbdr0u">
            <dt className="sr-only" data-id="element-149" data-mp="6048qzuv2ndb">{s.label}</dt>
            <dd className="font-display text-3xl font-bold text-pumpkin sm:text-5xl" data-id="element-150" data-mp="61fcizob3v4f">{s.value}</dd>
            <dd className="mt-1 text-sm text-mist" data-id="element-151" data-mp="jwzvfv41cdbu">{s.label}</dd>
          </div>)}
      </dl>

      <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-2" aria-label="Temas" data-id="element-152" data-mp="exwou68epz1r">
        {topics.map(t => <li key={t} className="rounded-full px-3 py-1 text-sm font-semibold text-mist ring-1 ring-line" data-id="element-153" data-mp="3jeha1bs1v4l5">{t}</li>)}
      </ul>

      <div className="mt-16 rounded-3xl bg-plum p-8 ring-1 ring-line sm:p-10" data-id="element-154" data-mp="10zz6840ynmg">
        <div className="grid gap-8 lg:grid-cols-[1fr_2fr]" data-id="element-155" data-mp="3senkspwd5qgm">
          <div data-id="element-156" data-mp="3sd2qn1dyo9ja">
            <h3 className="font-display text-2xl font-semibold text-bone" data-id="element-157" data-mp="34p1qoguum1fh">Incluido en el Megapack</h3>
            <p className="mt-3 text-mist" data-id="element-158" data-mp="2zqi4cfccenml">
              Funciona desde hoy en tu casa, con materiales que conseguís en cualquier librería o cotillón de Argentina.
            </p>
          </div>
          <ul className="grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-159" data-mp="18lx013fkbp6i">
            {included.map(i => <li key={i} className="flex items-center gap-3 text-bone" data-id="element-160" data-mp="1dd5am2smpgl9">
                <CheckIcon className="h-5 w-5 shrink-0 text-slime" aria-hidden="true" data-id="element-161" data-mp="1df99g6bo7peo" />
                {i}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}